module.exports = __webpack_public_path__ + "img/montevideo.de164dae.jpg";